import { Button } from '@components/_ui/Button'
import { Loader } from '@components/_ui/Loader'
import { PriceDetail } from '@components/PriceDetail'
import { useFetch } from '@hooks/useFetch'
import { usePrice } from '@hooks/usePrice'
import { usePriceSetter } from '@hooks/usePriceSetter'
import { useSteps } from '@hooks/useSteps'
import { useFormContext } from 'react-hook-form'

import s from './Form.module.scss'
import type { FormProps } from './Form.props'

export function Form({ data }: FormProps) {
  return (
    <div className={s.form}>
      <div className={s.hr} />

      <PriceDetail withActions />
    </div>
  )
}

function FormButton({ data }: FormProps) {
  const priceData = usePrice()
  const setPriceData = usePriceSetter()
  const { trigger, isLoading } = useFetch('remove_from_total')
  const { stepsHistory, setStepsHistory, setCurrentStep } = useSteps()

  const { setValue } = useFormContext()

  const nextStep = 6
  const newHistory = [...stepsHistory, 6]

  const goToNextStep = () => {
    setCurrentStep(nextStep)
    setStepsHistory(newHistory)
  }

  const nextHandler = () => {
    if (priceData?.removed_items?.length) {
      trigger({ data: priceData.removed_items, current_screen: nextStep, history: newHistory })
        .then((res: { data: { data: { totals: any, fields: { name: string, value: any } } } }) => {
          const data = res?.data?.data

          Object.entries(data?.fields)?.forEach(([key, value]) => {
            setValue(key, value)
          })
          setPriceData((prev) => ({ ...prev, ...data?.totals, removed_items: [] }))
          goToNextStep()
        })
    } else {
      goToNextStep()
    }
  }

  return (
    <Button
      onClick={nextHandler}
      disabled={isLoading}
    >
      {isLoading ? <Loader /> : 'Approve & Schedule Cleaning'}
    </Button>
  )
}

Form.Button = FormButton
